// 語言切換(Account → 偏好)。changeLanguage 經 detector 寫回 localStorage(ls.lang)。
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, setLanguage, type LangCode } from '../i18n';

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  // i18n.language 可能帶 region(zh-Hant-TW)→ 取 base 比對 supportedLngs
  const current = SUPPORTED_LANGUAGES.find((l) => i18n.language?.startsWith(l.code))?.code ?? 'zh-Hant';
  return (
    <label style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-3)' }}>
      <span>{t('account.language')}</span>
      <select
        data-testid="language-switcher"
        aria-label={t('account.language')}
        value={current}
        onChange={(e) => setLanguage(e.target.value as LangCode)}
      >
        {SUPPORTED_LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.label}
          </option>
        ))}
      </select>
    </label>
  );
}
